<!-- //
产品介绍
@author xuyd
@date 2024-09-29
//-->
<template>
  <page-layout layout="C">
    <div class="layout-result" style="height: 100%;margin-top: 5px;overflow-y: auto;">
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small">

      </el-form>
    </div>
  </page-layout>
</template>
<script>
import FormBlock from '@/components/Form/form-block'

export default {
  name: 'ViewSolutionIntro',
  components: {FormBlock},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {
      formMetaData: [],
      form:{},
      rules:[],
    }
  },
  created() {
    this.initMetaData();
  },
  methods: {
    /**
     * 初始化元数据
     */
    initMetaData() {
      setTimeout(() => {
        this.formMetaData = [
          {label: "信托要素", inputType: ''}
        ];
      }, 200);
    }
  }
}

</script>

<style lang="less" scoped>
.layout-search {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
